<template>
  <section class="topstyle">
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
      style="margin: 10px auto 0px 15px"
    ></toolbar>
    <el-select
      id="inputselect"
      v-model="filters.HertCategoryId"
      placeholder="请选择类型"
      style="width: 200px; margin: 0px auto 10px 15px"
    >
      <el-option
        v-for="(item, index) in this.HertCategorylist"
        :key="index"
        :label="item.CateName"
        :value="item.Type"
      ></el-option>
    </el-select>

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        label=" "
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="Title"
        label="标题"
        width="200"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <!-- <el-table-column
        prop="Thelabel"
        label="类型"
        width="200"
        sortable
        align="center"
      ></el-table-column> -->
      <!-- <el-table-column
        prop="Status"
        label="是否发布"
        width="150"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.Status == 2 ? "已发" : "未发" }}
        </template></el-table-column
      > -->
      <el-table-column
        prop="Img"
        label="封面"
        width="100"
        align="center"
        sortable
      >
        <template slot-scope="scope">
          <div>
            <el-image
              :src="scope.row.Img"
              fit="contain"
              @click.native="Logimg.push(scope.row.Img)"
            >
            </el-image>
          </div>
        </template>
        <!-- 图片的显示 -->
      </el-table-column>
      <!-- <el-table-column prop="Status" label="状态" width sortable align="center">
        <template slot-scope="scope">
          <span
            :style="
              scope.row.Status == 1
                ? 'color:red'
                : scope.row.Status == 2
                ? 'color:#60b934'
                : 'color:#007aff'
            "
          >
            {{
              scope.row.Status == 1
                ? "未开始"
                : scope.row.Status == 2
                ? "进行中"
                : "已结束"
            }}</span
          >
        </template>
      </el-table-column> -->
      <!-- :formatter="formatCreateTime" -->
      <el-table-column
        prop="BeginTime"
        label="开始时间"
        sortable
        align="center"
      ></el-table-column>

      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="onLookDatas(scope.row.Id)"
            >课程目录</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="200px" align="center">
        <template slot-scope="scope">
          <!-- <span class="SpanList">查看二维码</span> -->
          <span class="SpanList" @click="handleEdit(scope.row.Id)">编辑</span>
          <span class="SpanList" @click="handleDel(scope.row.Id)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        style="margin-top: 20px"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="15"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="90px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.Title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="课程分类" prop="Type">
          <el-select v-model="editForm.Type" placeholder="请选择课程分类">
            <el-option
              v-for="(item, index) in this.HertCategorylist"
              :key="index"
              :label="item.CateName"
              :value="item.Type"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="Img">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="editForm.Img" :src="editForm.Img" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="editForm.IsStick" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Sticklist"
              :label="item.Name"
              :value="item.IsStick"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="是否发布" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <!--使用编辑器
        -->
        <!--使用编辑器
        -->
        <el-form-item label="音乐" prop="Music" v-if="IsMusic == 2">
          <el-upload
            class="avatar-uploader"
            action=""
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:show-file-list="false"
            :http-request="beforeUploadVideo"
          >
            <audio
              v-if="editForm.Music != ''"
              style="width: 300px; height: 55px; padding: 10px"
              v-bind:src="addForm.Music"
              class="avatar video-avatar"
              controls="controls"
            >
              您的浏览器不支持音乐播放
            </audio>
            <i
              style="width: 300px; height: 20px"
              v-else-if="addForm.Music == '' && videoFlag == false"
              class="el-icon-plus avatar-uploader-iconss"
            ></i>
            <el-progress
              :text-inside="true"
              :stroke-width="30"
              v-if="videoFlag == true"
              v-bind:percentage="videoUploadPercent"
              style="width: 300px; line-height: 40px; padding: 2px 0 4px 0"
              status="exception"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="时长" prop="TimeLog" v-if="IsMusic == 2">
          <el-input v-model="editForm.TimeLog" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="详细" prop="Conten">
          <div id="edit_container"></div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      class="my-dialog-name"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          新增
          <span
            @click="DialogDown()"
            style="float: right; width: 100px; font-size: 20px; cursor: pointer"
            >x</span
          >
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="标题" prop="Title">
          <el-input v-model="addForm.Title" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="Thelabel">
          <el-input v-model="addForm.Thelabel" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="课程分类" prop="Type">
          <el-select v-model="addForm.Type" placeholder="请选择课程分类">
            <el-option
              v-for="(item, index) in this.HertCategorylist"
              :key="index"
              :label="item.CateName"
              :value="item.Type"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="Img">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="addForm.Img" :src="addForm.Img" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="是否置顶" prop="IsStick">
          <el-select v-model="addForm.IsStick" placeholder="请选择状态">
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item> -->

        <!-- <el-form-item label="课程或者文章" prop="IsStick">
          <el-select v-model="addForm.Istrue" placeholder="请选择状态">
            <el-option label="课程" value="true"></el-option>
            <el-option label="文章" value="false"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="分数" prop="Stroc">
          <el-input v-model="addForm.Stroc" auto-complete="off"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="有无音频">
          <el-select v-model="IsMusic" placeholder="请选择状态">
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <!--使用编辑器
        -->
        <el-form-item label="音乐" prop="Music" v-if="IsMusic == 2">
          <el-upload
            class="avatar-uploader"
            action=""
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:show-file-list="false"
            :http-request="beforeUploadVideo"
          >
            <audio
              v-if="addForm.Music != ''"
              style="width: 300px; height: 55px; padding: 10px"
              v-bind:src="addForm.Music"
              class="avatar video-avatar"
              controls="controls"
            >
              您的浏览器不支持音乐播放
            </audio>
            <i
              style="width: 300px; height: 20px"
              v-else-if="addForm.Music == '' && videoFlag == false"
              class="el-icon-plus avatar-uploader-iconss"
            ></i>
            <el-progress
              :text-inside="true"
              :stroke-width="30"
              v-if="videoFlag == true"
              v-bind:percentage="videoUploadPercent"
              style="width: 300px; line-height: 40px; padding: 2px 0 4px 0"
              status="exception"
            ></el-progress>
          </el-upload>
        </el-form-item>
        <el-form-item label="时长" prop="TimeLog" v-if="IsMusic == 2">
          <el-input v-model="addForm.TimeLog" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="详细" prop="Conten">
          <div class="edit_container" id="Add_container"></div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  GetaAdminHeraList,
  GetAdminTypeList,
  AddHera_Popular,
  UploadImg,
  DelHera_Popular,
  GetAdminHeraDetails,
  ModifiHera_Popular,
  coursecatalogsupdate,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import E from "wangeditor";

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      IsMusic: null,
      ///视频
      videoUploadPercent: 0,
      isShowUploadVideo: false,
      videoFlag: false,
      //
      editor: null,
      Logimg: [],
      editorOption: {},
      dialogVisible: false,
      formLabelWidth: "80px",
      limitNum: 1,
      buttonList: [],
      HertCategorylist: [],
      Sticklist: [
        { Id: 1, Name: "是", IsStick: true },
        { Id: 2, Name: "否", IsStick: false },
      ],
      Statuslist: [
        { Id: 1, Name: "发布", Status: 2 },
        { Id: 2, Name: "草稿", Status: 1 },
      ],
      currentRow: null,
      filters: {
        Title: "",
        HertCategoryId: null,
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        Type: [{ required: true, message: "课程类型", trigger: "blur" }],
        Conten: [{ required: true, message: "详情", trigger: "blur" }],
        Img: [{ required: true, message: "图片", trigger: "blur" }],
        Music: [{ required: true, message: "图片", trigger: "blur" }],
        TimeLog: [{ required: true, message: "音频", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Type: null,
        Title: "",
        Conten: "",
        Img: "",
        Score: 0,
        Music: "",
        TimeLog: 0,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        Type: [{ required: true, message: "课程类型", trigger: "blur" }],
        Conten: [{ required: true, message: "详情", trigger: "blur" }],
        Img: [{ required: true, message: "图片", trigger: "blur" }],
        Music: [{ required: true, message: "音频", trigger: "blur" }],
        TimeLog: [{ required: true, message: "音频时长", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Type: null,
        Title: "",
        Conten: "",
        Img: "",
        Score: 0,
        Music: "",
        TimeLog: 0,
      },
    };
  },
  methods: {
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    // 查看数据
    onLookDatas(id) {
      //this.$router.push('/Course/courseData_index')

      this.$router.push({
        path: "/Course/courseData_index",
        query: { Id: id },
      });
    },
    //上传前回调
    beforeUploadVideo(item) {
      console.log(item);
      // if (["audio/mp3"].indexOf(file.type) == -1) {
      //   this.$message.warning("请上传正确的音频格式");
      //   return false;
      // }
      this.isShowUploadVideo = false;
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.Music = response.data.response;
        this.editForm.Music = response.data.response;
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
      console.log(file);
      // this.videoFlag = true
      this.videoUploadPercent = 0;
      this.videoFlag = true;
      const interval = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval(interval);
          return;
        }
        this.videoUploadPercent += 1;
      }, 0.1);
      if (this.videoUploadPercent == 100) this.videoFlag = false;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      console.log(res);
      //后台上传地址
      if (res.success) {
        // this.videoForm.showVideoPath = res.url;
        // this.addForm.Music = this.videoForm.showVideoPath;
        // this.editForm.Music = this.videoForm.showVideoPath;
        this.itemForm_Sigin.Music = this.videoForm.showVideoPat;
        this.itemForm_SiginEdit.Music = this.videoForm.showVide;
        //this.itemFormEditSigin.Vidoe = this.videoForm.showVideoPath;
        this.$message.success({ title: "温馨提示：", message: "上传成功" });
      } else {
        this.$message.warning({ title: "温馨提示：", message: "上传失败" });
        this.$message.warning(res.response.url);
      }
    },
    onEditorReady(editor) {},
    // 上传文件之前的钩子
    handleAvatarSuccess(res, file) {
      this.addForm.Img = URL.createObjectURL(file.raw);
      console.log(this.addForm.Img);
    },
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于2M",
        });
      }
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        if (response.data.success) {
          this.addForm.Img = response.data.response;
          this.editForm.Img = response.data.response;
          console.log("filename", this.addForm.ListImg);
          this.$message.info("文件：" + fileObj.name + "上传成功");
        } else {
          this.$message.info("文件：" + fileObj.name + "上传失败");
        }
      });
    },
    //获取课程类型
    getcoursetypelist() {
      GetAdminTypeList({ Type: 4 }).then((res) => {
        this.HertCategorylist = res.data.response;
        this.filters.HertCategoryId = this.HertCategorylist[0].Type;
        this.getLists();
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      console.log(item);
      this.filters.Title = item.search;
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function (row, column) {
      return row.bcontent ? row.bcontent.substring(20) : "N/A";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    getModules() {
      this.page = 1;
      console.log("getModules");
      this.getLists();
    },
    //获取列表
    getLists() {
      let para = {
        PageIndex: this.page,
        Name: this.filters.Title,
        Id: 15,
      };
      this.listLoading = true;
      GetaAdminHeraList(para).then((res) => {
        console.log(res);
        if (res.data.success) {
          this.AddRecordInfo(
            "查询",
            "活动咨询管理-咨询中心介绍-查看自咨询中心介绍列表"
          );
          console.log(res);
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
        } else {
          this.users = [];
          this.total = 0;
        }

        this.listLoading = false;
      });
    },
    //删除
    handleDel(id) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { Ids: [id] };
          DelHera_Popular(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo(
                "删除",
                "活动咨询管理-咨询中心介绍-删除咨询中心介绍列表"
              );
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(id) {
      GetAdminHeraDetails({ Id: id }).then((res) => {
        if (res.data.success) {
          this.editFormVisible = true;
          this.editForm = res.data.response;
          this.IsMusic = this.editForm.Music == "" ? 3 : 2;
          this.$nextTick(() => {
            this.$refs["editForm"].clearValidate();
          });
        }
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Type: null,
        Title: "",
        Conten: "",
        Img: "",
        Score: 0,
        Music: "",
        TimeLog: 0,
      };

      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
    },
    Addwangeditor() {
      var c = document.getElementById("Add_container").innerHTML;
      //debugger;
      if (c == "" || c.length <= 0) {
        this.editor = new E("#Add_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.create();
      }
      if (c != null) {
        this.editor.txt.html(" ");
      }
    },
    Editwangeditor() {
      var c = document.getElementById("edit_container").innerHTML;
      //console.log(c);
      if (c.length <= 0) {
        console.log("chua");
        this.editor = new E("#edit_container");
        //this.editor.customConfig.debug = true;
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.txt.html(this.editForm.Conten);
        this.editor.create();
        console.log(this.editor.txt.html());
      }
      if (c != null) {
        this.editor.txt.html(this.editForm.Conten);
      }
    },
    //编辑
    editSubmit: function () {
      if (this.editor != null) {
        this.editForm.Conten = this.editor.txt.html();
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            // console.log(para);
            ModifiHera_Popular(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.editFormVisible = false;
                this.getLists();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      if (this.editor != null) {
        this.addForm.Conten = this.editor.txt.html();
      }
      console.log(this.addForm);
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              //   para.CreateId = user.uID;
              //   para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            AddHera_Popular(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.AddRecordInfo(
                  "新增",
                  "活动咨询管理-咨询中心介绍-新增自咨询中心介绍列表"
                );
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getLists();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  mounted() {
    this.getLists();

    this.getcoursetypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style  scoped>
.my-dialog-name .el-dialog__header {
  padding: 0 20px;
}
</style>